import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';
import lookup from '@/store/modules/lookup';
import slots from '@/store/modules/slots';
import reservation from '@/store/modules/reservation';
import payment from '@/store/modules/payment';
import user from '@/store/modules/user/user';

const vuexSessionStorage = new VuexPersist({
  key: 'ridmv',
  storage: window.sessionStorage,
  reducer: state => ({
    user: {
      resCategory: state.user.resCategory,
      resType: state.user.resType,
      resTypeForCustomer: state.user.resTypeForCustomer,
      resFeeApplicable: state.user.resFeeApplicable,
      resSlot: state.user.resSlot,
      resDetails: state.user.resDetails,
      resAppointmentNum: state.user.resAppointmentNum,
      resAppointmentBarcode: state.user.resAppointmentBarcode,
      resAppointmentLocation: state.user.resAppointmentLocation,
      resNotificationSent: state.user.resNotificationSent,
      reservationSlotId: state.user.reservationSlotId,
      reservationUserId: state.user.reservationUserId,
      resSlotHoldEndTime: state.user.resSlotHoldEndTime,
      resLookup: state.user.resLookup,
      resSelectedForUpdate: state.user.resSelectedForUpdate,
      showModalAlert: state.user.showModalAlert,
      ocaCustomerType: state.user.ocaCustomerType,
    }
  })
});

// Create the new store instance
export default createStore({
  modules: {
    user,
    lookup,
    slots,
    reservation,
    payment,
  },
  plugins: [vuexSessionStorage.plugin]
});